// JavaScript для footer
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для footer
});
